import { create } from "zustand";

import { Notification } from "~/types/notifications";

const defaultNotifications = {
    severity: undefined,
    message: "",
    autoHide: true,
};

interface NotificationsState {
    notifications: Notification;
    setNotifications: (notifications: any) => void;
    resetNotifications: () => void;
}

export const useNotificationsStore = create<NotificationsState>(set => ({
    notifications: defaultNotifications,
    setNotifications: notifications => set({ notifications }),
    resetNotifications: () => set({ notifications: defaultNotifications }),
}));
